import { render } from "./SliderComp.vue?vue&type=template&id=876a2252&scoped=true"
import script from "./SliderComp.vue?vue&type=script&lang=js"
export * from "./SliderComp.vue?vue&type=script&lang=js"

import "./SliderComp.vue?vue&type=style&index=0&id=876a2252&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-876a2252"]])

export default __exports__